import { z } from "zod";

import { organisationSchema } from "./organisation.type";
import { questionnaireSchema } from "./questionnaire.type";

export const questionnaireResponseSchema = z.object({
  id: z.coerce.string(),
  organisationId: organisationSchema.shape.id,
  questionnaireId: questionnaireSchema.shape.id,
  createdAt: z.coerce.date(),
  topParentName: z.string().nullable().optional(),
});

export type QuestionnaireResponse = z.infer<typeof questionnaireResponseSchema>;
